import React from 'react';

import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { alpha, Box, IconButton, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import colors from '../../theme/colors';

interface BackButtonProps {
  clickHandler?: () => void;
  label?: string;
  showLabel?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({
  clickHandler,
  label = 'Back',
  showLabel = true,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleClick = () => {
    if (clickHandler) {
      clickHandler();
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateX(-4px)',
        },
      }}
      onClick={handleClick}
    >
      <IconButton
        size="small"
        sx={{
          backgroundColor: alpha(colors.primary, 0.1),
          color: colors.primary,
          mr: showLabel ? 1 : 0,
          '&:hover': {
            backgroundColor: alpha(colors.primary, 0.2),
            transform: 'scale(1.1)',
          },
          transition: 'all 0.2s ease-in-out',
        }}
      >
        <ArrowBackIcon fontSize="small" />
      </IconButton>
      {showLabel && (
        <Typography
          variant="body2"
          sx={{
            color: colors.primary,
            fontWeight: 500,
            userSelect: 'none',
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default BackButton;
